/**
 * Route for `cookieless-fallback`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CookielessFallbackPage } from "../features/cookieless-fallback/CookielessFallbackPage";

export const cookielessFallbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cookieless-fallback",
	component: CookielessFallbackPage,
});

export default cookielessFallbackRoute;
